App.directive('formChildTpl', ['$window', 'Config', '$filter', 'statesService', '$q', function ($window, Config, $filter, statesService, $q) {
    return {
        restrict: 'AEC',
        scope: {
            form: '=',
            model: '=',
            prefix: '@',
            withSibling: '=',
            zoch: '=',
            addressToApply: '<?'
        },
        templateUrl: Config.TEMPLATES_DIR + 'Components/form-child-tpl.html',
        controller: ['$scope', function ($scope) {
            var self = this;
            var getResults = function (query) {
                var deferred = $q.defer();

                statesService.dataCityLists({
                    name: query
                }).then(function (data) {
                    deferred.resolve(data.data);
                });

                return deferred.promise;
            };

            // ##### LOCALIZATION FILTER ##### //
            $scope.querySearchLocalization = function (query) {
                if (!query) {
                    return;
                }

                return getResults(query).then(function (results) {
                    return results;
                });
            };

            if (!angular.isDefined($scope.model.partner)
                || !$scope.model.partner) {
                $scope.model['partner'] = {
                    citizenshipType: 'POLISH',
                    birthdate: null
                };
            }

            if (!angular.isDefined($scope.model.assured)
                || !$scope.model.assured) {
                $scope.model['assured'] = [{
                    type: 'PERSON',
                    country: 'POLISH',
                    personBirthdate: null,
                    sameAddress: true
                }];
            }

            $scope.addAssured = function () {
                if ($scope.model['assured'].length < 4) {
                    $scope.model['assured'].push({
                        type: 'PERSON',
                        country: 'POLISH',
                        personBirthdate: null,
                        sameAddress: true
                    });
                }
            };

            $scope.deleteAssured = function (obj) {
                $scope.model['assured'].splice(obj, 1);
            }


            self.$onInit = function () {
                $scope.sameAddressAsUser = !!$scope.addressToApply;
            };

            self.$onChanges = function (changes) {
                console.log('[formChildTpl] [$onChanges]', changes);
                if (changes && changes.addressToApply) {
                    $scope.sameAddressAsUser = !!$scope.addressToApply;
                }
            };

            $scope.additional = {
                notExistEmail: false,
                notExistPhone: false
            }

            $scope.$watch('additional.notExistEmail', function (oldVal, newVal) {
                console.log(oldVal, newVal);
                if (oldVal !== newVal) {
                    if ($scope.additional.notExistEmail) {
                        $scope.model['person'].email = '';
                    }
                }
            }, true);

            $scope.$watch('additional.notExistPhone', function (oldVal, newVal) {
                console.log(oldVal, newVal);
                if (oldVal !== newVal) {
                    if ($scope.additional.notExistPhone) {
                        $scope.model['person'].phone = '';
                    }
                }
            }, true);
        }]
    };
}]);